import { CSSObject } from '@emotion/react'

export const clientInfoStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>
} => ({
  root: {
    borderRadius: '8px',
  },
  header: {
    display: 'flex',
    cursor: 'pointer',
    borderWidth: 1,
    borderColor: 'red',
    maxWidth: 170,
    padding: '12px 16px',
    background: '#fff',
    alignItems: 'center',
  },
  headerText: {
    color: '#000',
    fontFamily: 'Gilroy-SemiBold',
    fontSize: 16,
    textAlign: 'left',
    fontWeight: 400,
    margin: 0,
  },
  contentContainer: {
    background: '#fff',
    padding: 30,
  },
  profileSection: {
    marginBottom: 20,
  },
  infoGrid: {
    padding: '0px 10px',
    minWidth: '50px',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
  },
  table: {
    width: '70%',
    borderCollapse: 'collapse',
    padding: '0px',
    height: 20,
  },

  labelCell: {
    padding: '10px 15px',
    fontWeight: 'bold',
    color: '#777',
    width: '30%',
    fontFamily: 'Gilroy-Regular',
    fontSize: 18,
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  valueCell: {
    width: '70%',
    padding: '10px 15px',
    color: '#333',
    fontFamily: 'Gilroy-Regular',
    fontSize: 18,
    fontWeight: 400,
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  qrSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30%',
  },
  actionButton: {
    cursor: 'pointer',
    border: '1px solid #595959',
    borderRadius: 24,
    padding: 4,
    justifyContent: 'center',
    margin: '10px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 200,
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  buttonIcon: {
    marginRight: 10,
  },
  buttonText: {
    fontSize: 14,
    color: '#595959',
    fontFamily: 'Gilroy-Regular',
    padding: '0px 4px',
    margin: 0,
  },
})
